module.exports = __webpack_public_path__ + "h5/static/img/bisheng-logo.62e3fb78.png";